import axios from 'axios';

const baseUrl = 'https://api.weatherapi.com/v1';
const key = process.env.WEATHER_API_KEY;

export const getCurrentWeather = () => {
  return axios.get<IWeatherResponse>(`${baseUrl}/current.json`, {
    params: {
      key,
      q: 'auto:ip',
    },
  });
};

export interface IWeatherResponse {
  current: { condition: { text: string }; temp_c: number };
  location: { name: string };
}
